import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["status", "testId"];
import React from 'react';
import AISummaryBlockResolvedView from './resolved';
import { SmartLinkStatus } from '../../../../../constants';

/**
 * Represents an AISummaryBlock, designed to summarising link resource
 * content using AI.
 * @public
 * @param {AISummaryBlockProps} AISummaryBlock
 * @see Block
 */
var AISummaryBlock = function AISummaryBlock(_ref) {
  var status = _ref.status,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? 'smart-ai-summary-block' : _ref$testId,
    props = _objectWithoutProperties(_ref, _excluded);
  if (status !== SmartLinkStatus.Resolved) {
    return null;
  }
  return /*#__PURE__*/React.createElement(AISummaryBlockResolvedView, _extends({}, props, {
    testId: testId
  }));
};
export default AISummaryBlock;